import { z } from 'zod'

export const shippingAddressSchema = z.object({
  first_name: z.string().min(1, 'First name is required'),
  last_name: z.string().min(1, 'Last name is required'),
  email: z.string().min(1, 'Email is required').email('Please enter a valid email address'),
  phone_number: z.string().min(1, 'Phone number is required'),
  street_address: z.string().min(1, 'Street address is required'),
  city: z.string().min(1, 'City is required'),
  postal_code: z.string().min(1, 'Postal code is required'),
  state_or_region: z.string().min(1, 'State or region is required'),
  country: z.string().min(1, 'Country is required'),
  latitude: z.union([z.number(), z.string()]).nullable().optional(),
  longitude: z.union([z.number(), z.string()]).nullable().optional(),
  is_default: z.boolean().optional(),
})

export type ShippingAddressFormData = z.infer<typeof shippingAddressSchema>
